"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetQualification = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var product_1 = require("../../model/product");
var service_1 = require("../../../library/base/service");
var GetQualification = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(GetQualification, _super);
    function GetQualification() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '购买资格查询接口';
        _this.code = '101043';
        _this.desc = '购买资格查询接口';
        _this.requestParams = new product_1.GetQualificationRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return GetQualification;
}(service_1.BaseService));
exports.GetQualification = GetQualification;
//# sourceMappingURL=getQualification.js.map